import React from 'react';

export default () => <div></div>;